import { Player } from "@remotion/player";
import {
  AbsoluteFill,
  Easing,
  interpolate,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import "./AnimatedDP3D.css";

const ease = Easing.bezier(0.16, 1, 0.3, 1);

function DPLogoScene() {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const entrance = interpolate(frame, [0, 0.8 * fps], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
    easing: ease,
  });
  const shine = interpolate(frame % (3 * fps), [0, 1.4 * fps, 3 * fps], [-80, 130, 220], {
    easing: ease,
  });
  const float = interpolate(frame % (2.8 * fps), [0, 1.4 * fps, 2.8 * fps], [0, -4, 0], {
    easing: ease,
  });

  return (
    <AbsoluteFill
      style={{
        alignItems: "center",
        justifyContent: "center",
        background: "transparent",
        transform: `translateY(${float}px)`,
      }}
    >
      <div
        style={{
          position: "relative",
          width: 86,
          height: 62,
          borderRadius: 22,
          background: "linear-gradient(145deg, #fff8df 0%, #f2c94c 48%, #b77900 100%)",
          boxShadow: "0 18px 34px rgba(101, 78, 28, 0.24)",
          opacity: entrance,
          transform: `scale(${0.82 + entrance * 0.18}) rotate(${(1 - entrance) * -8}deg)`,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "absolute",
            inset: 5,
            borderRadius: 18,
            background: "rgba(43, 36, 22, 0.9)",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: -30,
            left: shine,
            width: 22,
            height: 130,
            background: "rgba(255, 255, 255, 0.42)",
            transform: "rotate(18deg)",
            filter: "blur(8px)",
          }}
        />
        <span
          style={{
            position: "absolute",
            left: 16,
            top: 13,
            color: "#fff8df",
            fontFamily: "Sora, Plus Jakarta Sans, Arial, sans-serif",
            fontSize: 31,
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: 0,
            textShadow: "3px 4px 0 rgba(183, 121, 0, 0.75)",
          }}
        >
          D
        </span>
        <span
          style={{
            position: "absolute",
            left: 40,
            top: 13,
            color: "#f2c94c",
            fontFamily: "Sora, Plus Jakarta Sans, Arial, sans-serif",
            fontSize: 31,
            fontWeight: 900,
            lineHeight: 1,
            letterSpacing: 0,
            textShadow: "3px 4px 0 rgba(0, 0, 0, 0.34)",
          }}
        >
          P
        </span>
      </div>
    </AbsoluteFill>
  );
}

export function AnimatedDP3D({ variant = "navbar", letters = "DP" }) {
  return (
    <div className={`dp3d dp3d--${variant}`} aria-label={letters}>
      <Player
        component={DPLogoScene}
        durationInFrames={120}
        fps={30}
        compositionWidth={96}
        compositionHeight={72}
        autoPlay
        loop
        muted
        controls={false}
        style={{ position: "absolute", inset: 0, width: "100%", height: "100%" }}
      />
      <span className="dp3d__fallback dp3d__fallback--d">D</span>
      <span className="dp3d__fallback dp3d__fallback--p">P</span>
    </div>
  );
}
